import React from 'react';
import './Teaching.css';

const SidebarProfile = () => (
  <aside className="sidebar-profile">
    <img src="./vinhkhiem_picture_picture.jpg" alt="Khiem Vinh Tran" className="sidebar-profile-img" />
    <h2 className="sidebar-profile-name">Khiem Vinh Tran</h2>
    <p className="sidebar-profile-title">Research Staff Member & Associate Lecturer</p>
    <p className="sidebar-profile-department">Faculty of Information System & Information System Laboratory</p>
    <p className="sidebar-profile-university">University of Information Technology, Vietnam National University, Ho Chi Minh City</p>
    <div className="profile-location">
      <i className="fas fa-map-marker-alt"></i>
      <span>
        <a href="https://maps.app.goo.gl/zVvn2fYphGEJXVRF7" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', color: '#007bff' }}>
          Room E9.1, UIT-VNUHCM, Quarter 6, Linh Trung, Thu Duc City
        </a>
      </span>
    </div>
    <div className="sidebar-social-links">
      <a href="mailto:khiemtv@uit.edu.vn" className="sidebar-social-link email" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-envelope"></i> Email
      </a>
      <a href="https://scholar.google.com.vn/citations?user=XT2PrJQAAAAJ&hl=vi" className="sidebar-social-link scholar" target="_blank" rel="noopener noreferrer">
        <i className="fas fa-graduation-cap"></i> Google Scholar
      </a>
      <a href="https://orcid.org/0000-0001-7128-2058" className="sidebar-social-link orcid" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-orcid"></i> ORCID
      </a>
      <a href="https://www.linkedin.com/in/khiem-tran-vinh/" className="sidebar-social-link flickr" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-linkedin"></i> LinkedIn
      </a>
      <a href="https://www.instagram.com/kvt0012/" className="sidebar-social-link instagram" target="_blank" rel="noopener noreferrer">
        <i className="fab fa-instagram"></i> Instagram
      </a>
    </div>
  </aside>
);

const Teaching = () => {
  return (
    <main className="main">
      <div className="sidebar-layout">
        <SidebarProfile />
        <div className="container">
          <div className="page-header">
            <h1>Teaching</h1>
          </div>
          <div className="content-section teaching-content">
            <h2>2025</h2>
            <ul className="course-list">
              <li className="course-item">
                <a href="#" className="course-code">Mobile Development</a> (Semester 2)
                <ul>
                  <li>Advanced Program in Information Systems</li>
                </ul>
              </li>
              <li className="course-item">
                <a href="#" className="course-code">Web and Database Development</a> (Semester 3)
                <ul>
                  <li> Joint Program with Birmingham City University</li>
                </ul>
              </li>
            </ul>
            
            <h2>2024</h2>
            <ul className="course-list">
              <li className="course-item">
                <a href="#" className="course-code">Introduction to Software Engineering</a> (Semester 1)
                <ul>
                  <li>Advanced Program in Information Systems</li>
                </ul>
              </li>
              <li className="course-item">
                <a href="#" className="course-code">Data Structures and Algorithms</a> (Semester 1)
                <ul>
                  <li> Advanced Program in Information Systems</li>
                </ul>
              </li>
              <li className="course-item">
                <a href="#" className="course-code">Introduction to Database</a> (Semester 1)
                <ul>
                  <li> Undergraduate course</li>
                </ul>
              </li>
            </ul>

            <h2>2023</h2>
            <ul className="course-list">
              <li className="course-item">
                <a href="#" className="course-code">Mobile Development</a> (Semester 2)
                <ul>
                  <li>Advanced Program in Information Systems</li>
                </ul>
              </li>
              <li className="course-item">
                <a href="#" className="course-code">Web Development</a> (Semester 1)
                <ul>
                  <li> Advanced Program in Information Systems</li>
                </ul>
              </li>
            </ul>

            <h2>2022</h2>
            <ul className="course-list">
            <li className="course-item">
                <a href="#" className="course-code">Data Mining and Applications</a> (Semester 2)
                <ul>
                  <li>Advanced Program in Information Systems</li>
                </ul>
              </li>
            <li className="course-item">
                <a href="#" className="course-code">IT Project Management</a> (Semester 2)
                <ul>
                  <li>Advanced Program in Information Systems</li>
                </ul>
              </li>
              <li className="course-item">
                <a href="#" className="course-code">Mobile Development</a> (Semester 2)
                <ul>
                  <li>Advanced Program in Information Systems</li>
                </ul>
              </li>
              <li className="course-item">
                <a href="#" className="course-code">Web Development</a> (Semester 1)
                <ul>
                  <li> Advanced Program in Information Systems</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Teaching; 